export const FilterElements = {
	filtersContainerId: 'filtersContainerId',
	clearFiltersBtnId: 'clearFiltersBtnId',
	applyFiltersBtnId: 'applyFiltersBtnId',
	closeFiltersBtnId: 'closeFiltersBtnId',
	validationError: 'validationError',
	filterCountId: 'filterCountId',
	filtersId: 'filtersId',
	filtersBtnId: 'filtersBtnId',
};
